import { useRefCapture } from '@/hooks/useRefCapture';

// Mount-once component that captures `?ref=<code>` on any page load and logs
// the click via the public log_share_click RPC. Stores the code in
// localStorage with a 30-day TTL so Register.jsx can attribute the signup.
//
// Rendered once at the app root inside the Router context.
export default function RefCaptureMount() {
  useRefCapture();
  return null;
}
